'use strict';

/**
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Cengiz Mardin <cm@humans.am>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('modules/settings/templates/modal/change-password.hbs');

var ChangePasswordModalView = LayoutView.extend({
    template: template,

    className: 'settings settings-change-password',

    ui: {
        closeButton: '[data-action="close"]',
        saveButton: '[data-action="save"]',
        password: '[name="password"]',
        oldPassword: '[name="password-old"]',
        retypedPassword: '[name="retyped-password"]',
    },

    events: {
        'click @ui.closeButton': 'actionClose',
        'click @ui.saveButton': 'actionSave',
        'keyup @ui.oldPassword': 'keyUp',
        'keyup @ui.password': 'keyUp',
        'keyup @ui.retypedPassword': 'keyUp',
    },

    minPasswordLength: 3,

    /**
     * Return true, if everthing is ok.
     * @returns {boolean}
     */
    isPasswordEntryOk: function(){
        var same = this.ui.password.val() === this.ui.retypedPassword.val();
        var passwordLength1 = this.ui.password.val().length >= this.minPasswordLength;
        var passwordLength2 = this.ui.retypedPassword.val().length >= this.minPasswordLength;
        var passwordLengthOld = this.ui.oldPassword.val().length >= 1;

        return (passwordLength1 && passwordLength2 && same && passwordLengthOld);
    },

    /**
     * Handles the keyup-event on password-input.
     */
    keyUp: function(){
        if (this.isPasswordEntryOk()){
            this.ui.saveButton.prop('disabled', false);
        } else {
            this.ui.saveButton.prop('disabled', true);
        }

        var same = this.ui.password.val() === this.ui.retypedPassword.val();
        var passwordLength1 = this.ui.password.val().length >= this.minPasswordLength;
        var passwordLength2 = this.ui.retypedPassword.val().length >= this.minPasswordLength;

        if (passwordLength1 && passwordLength2){
            if (same){
                this.ui.password.parent().removeClass('error');
                this.ui.retypedPassword.parent().removeClass('error');
                this.ui.password.parent().addClass('success');
                this.ui.retypedPassword.parent().addClass('success');
            } else {
                this.ui.password.parent().addClass('error');
                this.ui.retypedPassword.parent().addClass('error');
                this.ui.password.parent().removeClass('success');
                this.ui.retypedPassword.parent().removeClass('success');
            }
        } else {
            this.ui.password.parent().removeClass('error');
            this.ui.retypedPassword.parent().removeClass('error');
            this.ui.password.parent().removeClass('success');
            this.ui.retypedPassword.parent().removeClass('success');
        }
    },

    actionClose: function (event) {
        this.trigger('close:modal');
    },

    /**
     * UI-Event
     * Speichern und schließen, wobei beim speichern erstmals eine/mehrere anfrage(n) an die API gesendet wird/werden.
     *
     * @param event
     */
    actionSave: function(event){
        App.user.changePassword(//@todo use {key:value} params
            this.ui.oldPassword.val(),
            this.ui.password.val(),
            function(){
                this.trigger('close:modal');
            }.bind(this),
            function(model, data){
                if (!_.isUndefined(data.responseJSON) && !_.isUndefined(data.responseJSON.message)) {
                    Messenger().post({
                        type: 'error',
                        message: App.t('settings::account:change-password:' + data.responseJSON.message),
                    });
                } else {
                    Messenger().post({
                        type: 'error',
                        message: App.t('settings::account:unknown-save-error'),
                    });
                }
            }.bind(this)
        );
    },
});

module.exports = ChangePasswordModalView;